<template>
  <section class="filter-box">
    <div class="top-btns">
      <el-button @click="$_add" class="btn__add">新增</el-button>
      <el-button @click="$_batchImport" class="btn__add">批量导入</el-button>
    </div>
    <el-form :inline="true" class="filter-form">
      <el-form-item label="运营商名称:">
        <div class="autocomplete-box">
          <el-autocomplete
            v-model="filter.platformName"
            :fetch-suggestions="$_handleSearchPlatform"
            :trigger-on-focus="false"
            value-key="platformName"
            @select="$_handleSelectPlatform"
            class="input-box"
          ></el-autocomplete>
          <div
            v-show="!searchPlatformData.length && filter.platformName"
            @click="$_clearSearchPlatformData"
            class="autocomplete-empty el-select-dropdown"
          >
            查无该运营商，请重新输入
          </div>
        </div>
      </el-form-item>

      <el-form-item label="品牌名称:">
        <div class="autocomplete-box">
          <el-autocomplete
            v-model="filter.brandName"
            :fetch-suggestions="$_handleSearchBrand"
            :trigger-on-focus="false"
            value-key="brandName"
            @select="$_handleSelectBrand"
            class="input-box"
          ></el-autocomplete>
          <div
            v-show="!searchBrandData.length && filter.brandName"
            @click="$_clearSearchBrandData"
            class="autocomplete-empty el-select-dropdown"
          >
            查无该品牌，请重新输入
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item label="定制系统">
        <el-select v-model="filter.sysType" filterable class="input-box">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in companyList"
            :key="item.sysType"
            :label="item.sysName"
            :value="item.sysType"
          >
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="定制系统:">
        <div class="autocomplete-box">
          <el-autocomplete
            v-model="filter.sysName"
            :fetch-suggestions="$_searchCCompanies"
            :trigger-on-focus="false"
            value-key="sysName"
            @select="$_selectCCompany"
            class="input-box"
          ></el-autocomplete>
          <div
            v-show="!searchCCompaniesData.length && filter.sysName"
            @click="$_clearSearchCCompanyData('supplier')"
            class="autocomplete-empty el-select-dropdown"
          >
            查无该定制系统，请重新输入
          </div>
        </div>
      </el-form-item>

      <el-form-item label="供应商:">
        <div class="autocomplete-box">
          <el-autocomplete
            v-model="filter.supplierName"
            :fetch-suggestions="$_searchSuppliers"
            :trigger-on-focus="false"
            value-key="supplierName"
            @select="$_selectSupplier"
            class="input-box"
          ></el-autocomplete>
          <div
            v-show="!searchSuppliersData.length && filter.supplierName"
            @click="$_clearSearchData('supplier')"
            class="autocomplete-empty el-select-dropdown"
          >
            查无该供应商，请重新输入
          </div>
        </div>
      </el-form-item>

      <el-form-item label="订阅名称:">
        <el-input v-model="filter.uniqueName" class="input-box"></el-input>
      </el-form-item>

      <el-form-item v-if="tab === 'org'" label="组织ID:">
        <el-input v-model="filter.departmentId" class="input-box"></el-input>
      </el-form-item>

      <el-form-item v-if="tab === 'user'" label="用户ID:">
        <el-input v-model="filter.userId" class="input-box"></el-input>
      </el-form-item>

      <el-form-item label="映射ID:">
        <el-input v-model="filter.mappingId" class="input-box"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="$_search" class="search__btn">查询</el-button>
        <el-button @click="$_reset" class="reset__btn">重置</el-button>
        <el-button @click="$_export" class="export__btn">导出</el-button>
      </el-form-item>
    </el-form>
    <!-- S 导出数据弹窗 -->
    <export-data
      v-if="modal.show && modal.template === 'export-data'"
      :title="modal.title"
      :filterData="modal.data"
      :actionName="exportActionName"
      @close="$_closeModal"
    ></export-data>
    <!-- E导出数据弹窗 -->
    <!-- S 批量导入数据弹窗 -->
    <batch-mapping
      v-if="modal.show && modal.template === 'batch-mapping'"
      :title="modal.title"
      :path="tab"
      @success="$_search"
      @close="$_closeModal"
    ></batch-mapping>
    <!-- E 批量导入数据弹窗 -->
  </section>
</template>

<script>
import autocompletePlatform from "@/mixins/autocompletePlatform";
import autocompleteBrands from "@/mixins/autocompleteBrands";
import autocompleteSuppliers from "@/mixins/autocompleteSuppliers";
import autocompleteCustomCompanys from "@/mixins/autocompleteCustomCompanys";
import ExportData from "@/components/modal/modal-export-data";
import BatchMapping from "./modal-batch-mapping";

export default {
  name: "filter-box",
  mixins: [
    autocompletePlatform,
    autocompleteBrands,
    autocompleteSuppliers,
    autocompleteCustomCompanys,
  ],
  props: ["tab"],
  data() {
    return {
      filter: {
        // platformName: "", // 运营商名称
        // brandName: "", // 品牌名称
        // supplierId: "", // 供应商id
        // sysType: "", // 定制系统编码
        uniqueName: "", // 订阅名称
        departmentId: "", // 组织id
        userId: "", // 用户id
        mappingId: "", // 映射id
      },
      companyList: [],
      exportActionName: "",
      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
    };
  },
  methods: {
    // 获取定制系统列表
    $_getCustomCompanys() {
      this.$service
        .post("getCustomCompanys", {
          pageNow: 1,
          pageSize: 999,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            this.companyList = result.data.rows.splice(0);
          }
        });
    },
    // 新增
    $_add() {
      this.$emit("add", -1);
    },
    // 批量导入
    $_batchImport() {
      this.modal.title = `批量导入${this.tab === "org" ? "组织" : "用户"}映射`;
      this.modal.template = "batch-mapping";
      this.modal.show = true;
    },
    // 搜索按钮
    $_search() {
      this.$emit("search", this.filter);
    },
    // 重置
    $_reset() {
      for (const [key, value] of Object.entries(this.filter)) {
        if (typeof value === "string") {
          this.filter[key] = "";
        } else if (typeof value === "number") {
          this.filter[key] = 0;
        }
      }
      this.$emit("reset", this.filter);
    },
    // 导出
    $_export() {
      this.modal.title = "提示";
      this.modal.template = "export-data";
      let filterData = Object.assign({}, this.filter);

      if (this.tab === "org") {
        this.exportActionName = "exportDepartmentMappings";
        delete filterData.userId;
      } else if (this.tab === "user") {
        this.exportActionName = "exportUserMappings";
        delete filterData.departmentId;
      }
      this.modal.data = Object.assign({}, filterData);
      this.modal.show = true;
    },
    // 关闭本弹窗激活的弹窗
    $_closeModal() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  created() {
    this.$_getCustomCompanys();
  },
  components: {
    ExportData,
    BatchMapping,
  },
};
</script>
<style lang="scss" scoped>
.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;
  .top-btns {
    height: 50px;
  }
}
.input-box {
  width: 110px;
}
</style>
